import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M8.2 2.875c.345 0 .625.28.625.625v1.275H13.9a.625.625 0 1 1 0 1.25h-1.854c-.487 2.48-1.45 4.753-2.816 6.723.377.253.757.466 1.126.632a.625.625 0 1 1-.512 1.14 9.047 9.047 0 0 1-1.364-.77 17.074 17.074 0 0 1-5.702 4.56.625.625 0 1 1-.556-1.12 15.824 15.824 0 0 0 5.265-4.201C6.337 12 5.322 10.74 4.774 9.443a.625.625 0 0 1 1.152-.486c.448 1.06 1.303 2.149 2.312 3.028a16.49 16.49 0 0 0 2.533-5.96H2.5a.625.625 0 0 1 0-1.25h5.075V3.5c0-.345.28-.625.625-.625Z"
    />
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m13.261 17.325-1.647 3.445a.625.625 0 1 1-1.128-.54l4.55-9.514a7.1 7.1 0 0 1 .282-.552c.085-.144.229-.358.479-.479a1.1 1.1 0 0 1 .956 0c.25.121.394.335.48.479.087.149.18.342.28.552l4.55 9.514a.625.625 0 0 1-1.127.54l-1.647-3.445H13.26Zm3.014-6.3.122.253 2.294 4.797h-4.832l2.294-4.797.122-.252Z"
      clip-rule="evenodd"
    />
  </svg>
`;
